module.exports = __webpack_public_path__ + "static/media/calendar-blue.7c3d0763.svg";